<script>
import app from 'app';

export default {
  render(h) {
    const modalData = this._modalContainerData();
    const transitionData = this._transitionData();
    const contentData = this._modalContentData();
    const contentChildren = this.showCloseButton
      ? [h('wt-close', this._closeButton())]
      : [];
    contentChildren.push(h('component', this._component()));

    return h('div', modalData, [
      h('transition', transitionData, [h('div', contentData, contentChildren)]),
    ]);
  },

  props: {
    component: { type: [String, Object, Function], required: true },
    componentPropsData: { type: Object },
    componentEvents: { type: Object, required: false, default: undefined },

    offset: {
      type: Object,
      default: void 0,
      validator(value) {
        return value && _.isNumber(value.left) && _.isNumber(value.top);
      },
    },

    type: {
      type: String,
      default: 'small',
      validator(value) {
        return [
          'small',
          'normal',
          'big',
          'fullscreen',
          'overlay',
          'custom',
          'fluid',
          'cropping',
          'custom scrollable',
        ].includes(value);
      },
    },

    backdrop: { type: Boolean, default: true },
    closeOnClickOut: { type: Boolean, default: false },
    closeOnEscape: { type: Boolean, default: true },
    transitionName: { type: String, default: 'modal-grow' },
    showCloseButton: { type: Boolean, default: true },
    whiteCloseButton: { type: Boolean, default: false },
    wrapperStyle: { type: Object, default: () => ({}) },
    wrapperClass: { type: [Array, Object], default: () => [] },
    analytics: { type: Function, default: _.noop },
  },

  mounted() {
    const handlers = [
      {
        on: 'keydown',
        key: $.ui.keyCode.ENTER,
        run: _.noop,
      },
    ];

    if (this.closeOnEscape) {
      handlers.push({
        on: 'keydown',
        key: $.ui.keyCode.ESCAPE,
        run: (event) => {
          this.analytics('modal-close', { Using: 'Escape' });
          return this.close(event);
        },
      });
    }

    app.keyboardAccessibility.add(`wt-base-modal-${this._uid}`, handlers);
  },

  beforeDestroy() {
    app.keyboardAccessibility.remove(`wt-base-modal-${this._uid}`);
  },

  methods: {
    close(e, payload) {
      // if event bubbled  up with __WT_STOP_PROPAGATION__
      // ignore it, and treat like a real stop propagation
      if (
        e &&
        (e.__WT_STOP_PROPAGATION__ ||
          (e.originalEvent && e.originalEvent.__WT_STOP_PROPAGATION__))
      ) {
        console.log(
          'wt-base-modal: close method was stopped by __WT_STOP_PROPAGATION__'
        );
        return;
      }

      this.$destroy();
      this.$el.remove();
      this.$parent.$emit('close', e, payload);
      this.$parent.$destroy();
    },

    _modalContainerData() {
      return {
        class: [
          this.wrapperClass,
          'wt2-modal',
          'wt2-sg',
          this.type,
          this.backdrop ? 'wt2-modal-backdrop' : '',
        ],
        style: this.wrapperStyle,
        on: {
          click: this.clickOnContainer,
        },
      };
    },

    _transitionData() {
      return {
        attrs: {
          name: this.transitionName,
          appear: 'appear',
        },
      };
    },

    _modalContentData() {
      return {
        class: ['wt2-modal-content'],
        style: this.offset
          ? {
              position: 'absolute',
              top: (this.offset.top || 0) + 'px',
              left: (this.offset.left || 0) + 'px',
            }
          : {},
      };
    },

    _closeButton() {
      return {
        class: [
          'wt2-text-lm',
          'close-icon',
          this.whiteCloseButton ? '-white' : '',
        ],

        nativeOn: {
          click: this.close,
        },
      };
    },

    _component() {
      return {
        is: this.component,
        props: Object.assign(
          {
            closeModal: this.close,
            analytics: this.analytics,
          },
          this.componentPropsData
        ),
        attrs: {
          'in-modal': true,
        },
        on: this.componentEvents,
      };
    },

    clickOnContainer(e) {
      if (this.closeOnClickOut && e.target.classList.contains('wt2-modal')) {
        this.close(e);
      }
    },
  },
};
</script>
